import React, { useState } from "react";
import Tooltip from "react-popper-spring-tooltip";
import GitHubButton from "react-github-btn";

import Content from "./Content";

function App() {
  const [trigger, setTrigger] = useState("click");
  const [isDuration, setIsDuration] = useState(false);

  const springProps = isDuration
    ? {
        from: {
          opacity: 0,
          scale: 0.8,
          config: { duration: 50 }
        },
        to: {
          opacity: 1,
          scale: 1,
          config: { duration: 50 }
        }
      }
    : {
        from: {
          opacity: 0,
          scale: 0.8,
          config: { mass: 1, tension: 250, friction: 20 }
        },
        to: {
          opacity: 1,
          scale: 1,
          config: { mass: 1, tension: 250, friction: 20 }
        }
      };
  const handleSetTrigger = e => {
    setTrigger(e.target.value);
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <h1 className="mt-6 md:mt-24 text-center text-2xl md:text-3xl font-bold text-gray-900">
          React Popper Spring Tooltip
        </h1>
        <div className="mt-3">
          <GitHubButton
            href="https://github.com/impulse/react-popper-spring-tooltip"
            data-icon="octicon-star"
            data-size="large"
            data-show-count="true"
            aria-label="Star impulse/react-popper-spring-tooltip on GitHub"
          >
            Star
          </GitHubButton>
        </div>
        <div className="mt-3 text-gray-800">
          <label className="inline-flex items-center">
            <input
              type="radio"
              className="form-radio"
              name="click"
              value="click"
              onChange={handleSetTrigger}
              checked={trigger === "click"}
            />
            <span className="ml-2">Click</span>
          </label>
          <label className="inline-flex items-center ml-6">
            <input
              type="radio"
              className="form-radio"
              name="hover"
              value="hover"
              onChange={handleSetTrigger}
              checked={trigger === "hover"}
            />
            <span className="ml-2">Hover</span>
          </label>
          <label className="inline-flex items-center ml-6">
            <input
              type="radio"
              className="form-radio"
              name="context"
              value="context"
              onChange={handleSetTrigger}
              checked={trigger === "context"}
            />
            <span className="ml-2">Context</span>
          </label>
        </div>
        <div className="mt-4 text-gray-800">
          <label className="inline-flex items-center">
            <input
              type="radio"
              className="form-radio"
              name="spring"
              checked={!isDuration}
              onChange={() => {
                setIsDuration(false);
              }}
            />
            <span className="ml-2">Spring</span>
          </label>
          <label className="inline-flex items-center ml-6">
            <input
              type="radio"
              className="form-radio"
              name="duration"
              checked={isDuration}
              onChange={() => {
                setIsDuration(true);
              }}
            />
            <span className="ml-2">Duration</span>
          </label>
        </div>
        <a
          href="https://www.tailwindui.com/"
          className="fixed bottom-0 mb-6 underline-anchor font-semibold text-base text-gray-800"
        >
          Menu Design by Tailwind UI
        </a>
        <div className="ml-32 md:ml-0 mt-8">
          <Tooltip
            closeOnClickOutside={true}
            trigger={trigger}
            placement="bottom-end"
            content={<Content />}
            springConfig={springProps}
          >
            {({ isOpen, ...bind }) => (
              <button
                {...bind}
                className={`${
                  isOpen ? "bg-gray-900" : "bg-gray-800 hover:bg-gray-700"
                } inline-flex items-center pl-6 pr-2 py-2 font-semibold text-white rounded-lg focus:outline-none active:bg-gray-900 select-none`}
              >
                Account
                <svg
                  className="ml-2 h-6 w-6 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z" />
                </svg>
              </button>
            )}
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default App;
